import { shallowEqual } from 'react-redux';

// robotId → Map(msgId → value) 구조의 텔레메트리 데이터 저장소
const data = new Map();
// key("robotId:msgId") → Set(listener) 구조의 구독자 목록
const listeners = new Map();
// 다음 프레임에 알림할 key 대기열
const pendingNotify = new Set();
let notifyScheduled = false;

function init(robotId) {
  if (data.has(robotId)) return;

  data.set(robotId, new Map());
}

function subscribe(key, listener) {
  if (!listeners.has(key)) {
    listeners.set(key, new Set());
  }

  const keyListeners = listeners.get(key);
  keyListeners.add(listener);

  // 구독 해제 함수 반환
  return () => {
    keyListeners.delete(listener);
    if (keyListeners.size === 0) {
      listeners.delete(key);
    }
  };
}

function set(robotId, msgId, value) {
  const robotData = data.get(robotId);
  // remove 이후 호출 시 크래시 방지
  if (!robotData) return;

  // 값이 동일하면 알림 스킵하여 불필요한 리렌더 방지
  const prev = robotData.get(msgId);
  if (prev !== undefined && shallowEqual(prev, value)) return;

  robotData.set(msgId, value);
  scheduleNotify(robotId, msgId);
}

function get(robotId, msgId) {
  return data.get(robotId)?.get(msgId);
}

function remove(robotId) {
  if (!data.has(robotId)) return;

  const prefix = `${robotId}:`;
  // 대기 중인 알림 제거
  for (const key of pendingNotify) {
    if (key.startsWith(prefix)) {
      pendingNotify.delete(key);
    }
  }
  // 리스너 제거
  for (const key of listeners.keys()) {
    if (key.startsWith(prefix)) {
      listeners.delete(key);
    }
  }

  data.delete(robotId);
}

// 같은 프레임 내 여러 set 호출을 하나의 알림으로 배치
function scheduleNotify(robotId, msgId) {
  pendingNotify.add(`${robotId}:${msgId}`);
  if (notifyScheduled) return;

  notifyScheduled = true;
  window.requestAnimationFrame(flushNotify);
}

// 대기열의 key별 구독자에게 변경 알림
function flushNotify() {
  notifyScheduled = false;

  for (const key of pendingNotify) {
    const keyListeners = listeners.get(key);
    if (!keyListeners) continue;

    for (const listener of keyListeners) {
      listener();
    }
  }

  pendingNotify.clear();
}

const telemetryStore = { init, subscribe, set, get, remove };

export default telemetryStore;
